// Mock data for Uzvi Services website

export const companyInfo = {
  name: "UZVI Services",
  tagline: "Find the Right Solution for your business",
  description: "Connect and bring intelligence to help your business and compete more effectively. Success is about making the right decisions at the right time.",
  phone: "+91 8500820088",
  email: "info@uzvis.com",
  location: "Vijayawada, India",
  highlights: [
    "Focus on quality first",
    "Get to the market on time"
  ]
};

export const navigation = [
  { name: "Home", href: "/", dropdown: null },
  { 
    name: "Company", 
    href: "/about",
    dropdown: [
      { name: "About Us", href: "/about" }
    ]
  },
  { 
    name: "Services", 
    href: "/services",
    dropdown: [
      { name: "SAP Services", href: "/services/sap" },
      { name: "Mobile Development", href: "/services/mobile" },
      { name: "Web Development", href: "/services/web" },
      { name: "Database Services", href: "/services/database" },
      { name: ".NET Services", href: "/services/dotnet" },
      { name: "Azure Services", href: "/services/azure" }
    ]
  },
  { 
    name: "Solutions", 
    href: "/solutions",
    dropdown: [
      { name: "Enterprise Solutions", href: "/solutions/enterprise" },
      { name: "Cloud Solutions", href: "/solutions/cloud" },
      { name: "Digital Transformation", href: "/solutions/digital" }
    ]
  },
  { name: "Case Studies", href: "/case-studies", dropdown: null },
  { name: "Contact", href: "/contact", dropdown: null },
  { name: "Blog", href: "/blog", dropdown: null }
];

export const partners = [
  { name: "Whitehall", logo: "https://placehold.co/150x60/ffffff/333333?text=Whitehall" },
  { name: "Danfoss", logo: "https://placehold.co/150x60/ffffff/333333?text=Danfoss" },
  { name: "Infosys", logo: "https://placehold.co/150x60/ffffff/0066cc?text=Infosys" },
  { name: "Nityo Infotech", logo: "https://placehold.co/150x60/ffffff/333333?text=Nityo" },
  { name: "Argano", logo: "https://placehold.co/150x60/ffffff/ff6633?text=Argano" },
  { name: "Recruit121", logo: "https://placehold.co/150x60/ffffff/333333?text=Recruit121" },
  { name: "TechPartner", logo: "https://placehold.co/150x60/ffffff/0099cc?text=TechPartner" },
  { name: "GlobalIT", logo: "https://placehold.co/150x60/ffffff/333333?text=GlobalIT" }
];

export const services = [
  {
    id: "sap",
    title: "SAP Services",
    icon: "database",
    items: [
      "SAP S/4 HANA Migration",
      "SAP Upgradation",
      "SAP Implementation",
      "SAP Consulting Services",
      "SAP Support Services"
    ],
    href: "/services/sap"
  },
  {
    id: "mobile",
    title: "Mobile Development",
    icon: "smartphone",
    items: [
      "Android Development Services",
      "iOS App Development Services",
      "Mobile Application Redesign",
      "Enterprise Mobile Apps",
      "Cross-Platform Development"
    ],
    href: "/services/mobile"
  },
  {
    id: "web",
    title: "Web Development",
    icon: "globe",
    items: [
      "Front-end Development",
      "Back-end Development",
      "eCommerce Website",
      "Full Stack Development",
      "Website Redesign"
    ],
    href: "/services/web"
  },
  {
    id: "database",
    title: "Database Services",
    icon: "server",
    items: [
      "Database Architecture Design",
      "Database Assessments",
      "Database Programming",
      "Database Administration(DBA)",
      "Database Deployments",
      "Database Migrations",
      "Database Managed Services"
    ],
    href: "/services/database"
  },
  {
    id: "dotnet",
    title: ".NET Services",
    icon: "code",
    items: [
      ".NET Core",
      "C#.NET",
      "ASP.NET",
      "Web Service",
      "ADO.NET",
      "Entity Framework Core",
      "Entity Framework 6"
    ],
    href: "/services/dotnet"
  },
  {
    id: "azure",
    title: "Azure Services",
    icon: "cloud",
    items: [
      "Azure AI services",
      "Azure DevOps",
      "Azure App Services",
      "Azure Database Services",
      "Application Development",
      "Cloud Migration",
      "Azure Network Security"
    ],
    href: "/services/azure"
  }
];

export const stats = {
  customers: "30+",
  projectsDone: "38",
  resultsGuaranteed: "100"
};

export const aboutContent = {
  title: "Welcome to The UZVI Services LLP",
  subtitle: "About Us",
  description: "We Are Professional in SAP, Java, Azure, .Net, Web Development and Database Services.",
  details: "We Are Serving Customers Worldwide. We Will Constantly Update Our Services. Our Team at UZVI Provides Excellent Strategic and Technical Support",
  avatars: [
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop"
  ]
};

export const globalImpact = {
  title: "Everywhere on the globe",
  subtitle: "Our Global Impact",
  description: "With success stories spanning continents, our presence is felt worldwide. From Europe, where we have a strong footprint across the entire region, to the dynamic business landscape of the USA. In South Asia, we make a significant impact in India, and in Africa, our influence is prominent in South Africa.",
  image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80"
};

export const caseStudies = [
  {
    id: 1,
    title: "SAP S/4HANA Migration for EngenOil",
    category: "SAP S/4HANA Migration",
    industry: "EngenOil, Petroleum industry",
    description: "EngenOil, a major player in the petroleum industry, faced increasing challenges with its legacy ERP system. The company was experiencing difficulties with real-time data processing, slow response times, and inefficiencies in managing critical functions like finance, supply chain, and asset management.",
    image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=800&q=80",
    href: "/case-studies/engenoil"
  },
  {
    id: 2,
    title: "SAP S/4HANA Migration at Sanofi",
    category: "SAP S/4HANA Migration",
    industry: "Sanofi – Pharmaceutical Organization",
    description: "Sanofi, a leading global pharmaceutical company headquartered in Paris, is renowned for its extensive product portfolio across prescription medicines, consumer healthcare, and vaccines. To continue driving innovation and improve operational efficiency, Sanofi embarked on a large-scale digital transformation journey.",
    image: "https://images.unsplash.com/photo-1573164574511-73c773193279?w=800&q=80",
    href: "/case-studies/sanofi"
  },
  {
    id: 3,
    title: "SAP S/4 HANA Migration for Ascensus",
    category: "SAP S/4HANA Migration",
    industry: "Ascensus, American financial services provider",
    description: "Ascensus, a prominent American financial services provider, specializes in retirement, college savings, and health savings solutions. Founded in 1980 and headquartered in Dresher, Pennsylvania, Ascensus has grown to manage over $400 billion in assets.",
    image: "https://images.unsplash.com/photo-1614928001197-55f0724d4ce4?w=800&q=80",
    href: "/case-studies/ascensus"
  }
];

export const workingProcess = [
  {
    step: "01",
    title: "Discovery Phase",
    description: "We work closely with you to understand your goals, challenges, and user needs, ensuring a strong foundation for the project ahead."
  },
  {
    step: "02",
    title: "Design and Development",
    description: "We collaborate with you to translate insights into intuitive design and seamless development, ensuring a solution that meets both user needs and business goals."
  },
  {
    step: "03",
    title: "Maintenance",
    description: "We provide ongoing support and maintenance to ensure your solution remains secure, up-to-date, and performs optimally as your business evolves."
  },
  {
    step: "04",
    title: "Deployment",
    description: "We ensure a smooth deployment of your solution, managing the process from launch to live environment, with careful attention to performance and scalability."
  },
  {
    step: "05",
    title: "Testing and QA",
    description: "We conduct thorough testing to identify and resolve any issues, ensuring your solution is reliable, user-friendly, and ready for launch."
  }
];

export const technologies = {
  sap: [
    "ABAP", "MDG", "BASIS", "CPI/DS", "PI/PO", "PP/QM", "EWM", "FICO", "MM", "SD", "UI5", "Solution Management", "S/4 HANA"
  ],
  web: [
    "JavaScript", "TypeScript", "Python", "Java", "C++", "Laravel"
  ],
  databases: [
    "MongoDB", "MySQL", "SQL Server", "SQLite", "PostgreSQL"
  ],
  cloud: [
    "Datadog", "Kubernetes", "Docker", "Jira", "Bitbucket", "Google Cloud", "AWS", "Terraform"
  ],
  mobile: [
    "Swift", "TypeScript", "Flutter", "PHP", "Ruby", "React JS"
  ]
};

export const testimonial = {
  title: "Seamless Execution",
  content: "UZVI has been an incredible partner for our S/4HANA Migration. Their technical expertise and seamless execution helped us transition without a hitch. Our infrastructure is now more reliable and scalable. Couldn't have done it without them!",
  author: "Samatha Mallarapu",
  role: "Project Delivery Lead",
  location: "Sweden",
  customerCount: "30+ Customers Worldwide",
  reviews: {
    google: "40+",
    clutch: "50+"
  }
};

export const articles = [
  {
    id: 1,
    title: "Unlocking New Opportunities",
    author: "Uzvi Services",
    date: "06/08/2024",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    href: "/blog/unlocking-opportunities"
  },
  {
    id: 2,
    title: "Innovate and Engage",
    author: "Uzvi Services",
    date: "06/08/2024",
    image: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&q=80",
    href: "/blog/innovate-engage"
  },
  {
    id: 3,
    title: "Transform Your Online Presence",
    author: "Uzvi Services",
    date: "06/08/2024",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    href: "/blog/transform-presence"
  }
];

export const contactSteps = [
  "Share your requirements",
  "Discuss with our experts",
  "Get a free quote",
  "Start the project"
];

export const footerLinks = {
  services: [
    { name: "SAP Services", href: "/services/sap" },
    { name: "Web Development", href: "/services/web" },
    { name: "Mobile Development", href: "/services/mobile" },
    { name: "Azure Services", href: "/services/azure" },
    { name: "Database Services", href: "/services/database" },
    { name: ".NET Services", href: "/services/dotnet" }
  ],
  company: [
    { name: "About Us", href: "/about" },
    { name: "Case Studies", href: "/case-studies" },
    { name: "Contact", href: "/contact" },
    { name: "Blog", href: "/blog" }
  ],
  social: [
    { name: "LinkedIn", href: "#", icon: "linkedin" },
    { name: "Instagram", href: "#", icon: "instagram" }
  ]
};
